import { ErrorBoundary } from '@sentry/react'

import { FCWithChildren } from 'types'

import { ErrorFallback } from './ErrorFallback'

export const TopLevelErrorBoundary: FCWithChildren = ({ children }) => {
  return (
    <>
      {process.env.NODE_ENV === 'test' ? (
        children
      ) : (
        <ErrorBoundary fallback={ErrorFallback}>{children}</ErrorBoundary>
      )}
    </>
  )
}
